import { companyRequest } from "./companyRequest";

// 获取公司下的设施列表
export const getFacilitysByCompanyId = async (companyId) => {
    const res = await companyRequest.get(`/portfolio/facilities?companyId=${companyId}`);
    console.log('getFacilitysByCompanyId:', res.data);
    return res.data;
}

// 获取能源数据（电力和燃气使用量和成本）
export const getPortfolioEnergyData = async (facilityIds, monthRange = null) => {
    const facilityIdsStr = Array.isArray(facilityIds) ? facilityIds.join(',') : facilityIds;
    let url = `/portfolio/energy_data?facilityIds=${facilityIdsStr}`;
    
    if (monthRange) {
        url += `&month=${monthRange.month}&ending_date=${monthRange.ending_date}`;
    }
    
    const res = await companyRequest.get(url);
    console.log('getPortfolioEnergyData:', res.data);
    return res.data;
}

// 获取EUI趋势数据
export const getPortfolioEuiTrend = async (facilityIds, monthRange = null) => {
    const facilityIdsStr = Array.isArray(facilityIds) ? facilityIds.join(',') : facilityIds;
    let url = `/portfolio/eui_trend?facilityIds=${facilityIdsStr}`;
    
    if (monthRange) {
        url += `&month=${monthRange.month}&ending_date=${monthRange.ending_date}`;
    }
    
    const res = await companyRequest.get(url);
    console.log('getPortfolioEuiTrend:', res.data);
    return res.data;
}

// 获取公司电力和天然气汇总数据
export const getCompanyElectricityGasSummary = async (companyId, monthRange) => {
    let url = `/company_electricity_gas_summary?company=${companyId}`;
    
    if (monthRange) {
        url += `&ending_date=${monthRange.ending_date}&month=${monthRange.month}`;
    }
    
    const res = await companyRequest.get(url);
    console.log('getCompanyElectricityGasSummary:', res.data);
    return res.data;
}

// 数据处理工具函数

// 将设施数据转换为组件需要的格式
export const transformFacilitiesData = (apiData) => {
    if (!apiData?.success || !apiData?.data?.facilities) {
        return [];
    }

    const colors = [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc"
    ];
    
    return apiData.data.facilities.map((facility, index) => ({
        id: facility.id,
        name: facility.name,
        company_name: facility.company_name,
        company_id: facility.company_id,
        category: facility.category,
        address: facility.address,
        area: facility.area,
        latitude: facility.latitude,
        longitude: facility.longitude,
        description: facility.description,
        image: facility.image,
        year: facility.year,
        eui: facility.eui,
        performance_breakdown: facility.performance_breakdown || [],
        performance_metrics: facility.performance_metrics || {},
        overall_score: facility.overall_score,
        color: colors[index % colors.length], // 根据索引分配颜色，超过长度时循环重复
    }));
}

// 处理能源数据，分别提取电力和燃气数据
export const transformEnergyData = (apiData) => {
    if (!apiData?.success || !apiData?.data) {
        return { electricityData: [], gasData: [] };
    }
    
    const allElectricityData = [];
    const allGasData = [];
    
    apiData.data.forEach(facilityData => {
        // 处理电力数据
        if (facilityData.electricity) {
            facilityData.electricity.forEach(item => {
                allElectricityData.push({
                    month: item.month,
                    usage: item.usage,
                    costs: item.costs,
                    facility_id: facilityData.facility_id,
                    facility_name: facilityData.facility_name
                });
            });
        }
        
        // 处理燃气数据
        if (facilityData.gas) {
            facilityData.gas.forEach(item => {
                allGasData.push({
                    month: item.month,
                    usage: item.usage,
                    costs: item.costs,
                    facility_id: facilityData.facility_id,
                    facility_name: facilityData.facility_name
                });
            });
        }
    });
    
    return { electricityData: allElectricityData, gasData: allGasData };
}

// 处理EUI趋势数据
export const transformEuiTrendData = (apiData) => {
    if (!apiData?.success || !apiData?.data) {
        return { electricityEUIData: [], gasEUIData: [] };
    }
    
    const allElectricityEUIData = [];
    const allGasEUIData = [];
    
    apiData.data.forEach(facilityData => {
        // 处理电力EUI数据
        if (facilityData.electricity_eui) {
            facilityData.electricity_eui.forEach(item => {
                allElectricityEUIData.push({
                    month: item.month,
                    rolling_eui: item.rolling_eui,
                    facility_id: facilityData.facility_id,
                    facility_name: facilityData.facility_name
                });
            });
        }
        
        // 处理燃气EUI数据
        if (facilityData.gas_eui) {
            facilityData.gas_eui.forEach(item => {
                allGasEUIData.push({
                    month: item.month,
                    rolling_eui: item.rolling_eui,
                    facility_id: facilityData.facility_id,
                    facility_name: facilityData.facility_name
                });
            });
        }
    });
    
    return { electricityEUIData: allElectricityEUIData, gasEUIData: allGasEUIData };
}

// 处理公司电力和天然气汇总数据
export const transformCompanySummaryData = (apiData) => {
    if (!apiData) {
        return {};
    }
    const summaryMap = {};
    const electricity_data = apiData.electricity_summary?.facilities_data ?? [];
    const gas_data = apiData.gas_summary?.facilities_data ?? [];

    electricity_data.forEach(item => {
        const facility_id = item.facility_id;

        if(!summaryMap[facility_id]) {
            summaryMap[facility_id] = {}
        }

        summaryMap[facility_id].electricity_total_usage = item.total_usage;
        summaryMap[facility_id].electricity_total_cost = item.total_cost;
    });

    gas_data.forEach(item => {
        const facility_id = item.facility_id;
        if(!summaryMap[facility_id]) {
            summaryMap[facility_id] = {}
        }
        summaryMap[facility_id].gas_total_usage = item.total_usage;
        summaryMap[facility_id].gas_total_cost = item.total_cost;
    });

    // 计算总成本
    Object.keys(summaryMap).forEach(facility_id => {
        const electricity_cost = summaryMap[facility_id].electricity_total_cost || 0;
        const gas_cost = summaryMap[facility_id].gas_total_cost || 0;
        summaryMap[facility_id].total_cost = electricity_cost + gas_cost;
    });
    
    return summaryMap;
}

// 生成图表数据的辅助函数
export const generateChartDataFromFacilities = (facilities) => {
    const result = facilities.map(facility => {
        // const breakdown = facility.performance_breakdown || [];
        const metrics = facility.performance_metrics || {};
        const totalScore = Object.values(facility.performance_metrics).reduce((sum, value) => sum + value, 0);
        return {
            facilityId: facility.id,
            facilityName: facility.name,
            totalScore: totalScore,
            overallScore: facility.overall_score,

            chartData: [
                {
                    name: 'Energy Efficiency',
                    value: metrics.energy_efficiency,
                },
                {
                    name: 'Equipment Condition',
                    value: metrics.equipment_condition,
                },
                {
                    name: 'Occupant Comfort',
                    value: metrics.occupant_comfort,
                },
                {
                    name: 'Service Efficiency',
                    value: metrics.service_efficiency,
                },
                {
                    name: 'Technology Adoption',
                    value: metrics.technology_adoption,
                },
                {
                    name: 'Cost Efficiency',
                    value: metrics.cost_efficiency,
                }
            ]
        };
    });

    return result;
}

// 生成雷达图数据
export const generateRadarDataFromFacilities = (facilities) => {
    return facilities.map(facility => {
        const breakdown = facility.performance_breakdown || [];
        const metrics = facility.performance_metrics || {};
        
        // 创建指标名称映射，用于从 performance_breakdown 中提取对应数据
        const indicatorMap = {
            'Energy Efficiency': 'energy_efficiency',
            'Equipment Condition': 'equipment_condition',
            'Occupant Comfort': 'occupant_comfort',
            'Service Efficiency': 'service_efficiency',
            'Technology Adoption': 'technology_adoption',
            'Cost Efficiency': 'cost_efficiency'
        };
        
        // 雷达图的指标顺序 - 使用6个指标
        const radarIndicators = [
            'Energy Efficiency',
            'Equipment Condition',
            'Occupant Comfort',
            'Service Efficiency',
            'Technology Adoption',
            'Cost Efficiency'
        ];
        
        // 从 performance_breakdown 或 performance_metrics 中获取真实数据
        const radarData = radarIndicators.map(indicator => {
            // 首先尝试从 performance_breakdown 中获取数据
            const breakdownItem = breakdown.find(item => 
                item.name === indicator || 
                item.name.toLowerCase().includes(indicator.toLowerCase().split(' ')[0])
            );
            
            if (breakdownItem && breakdownItem.score !== undefined) {
                return breakdownItem.score;
            }
            
            // 如果 breakdown 中没有，尝试从 performance_metrics 中获取
            const metricKey = indicatorMap[indicator];
            if (metrics[metricKey] !== undefined) {
                return metrics[metricKey];
            }
            
            // 如果都没有真实数据，返回 0
            return 0;
        });
        
        return {
            facilityId: facility.id,
            facilityName: facility.name,
            radarData: radarData
        };
    });
}

// 聚合月度数据（用于整体图表显示）
export const aggregateMonthlyData = (data, type = 'sum') => {
    const monthlyMap = {};
    
    data.forEach(item => {
        const month = item.month;
        if (!monthlyMap[month]) {
            monthlyMap[month] = {
                month,
                usage: 0,
                costs: 0,
                count: 0
            };
        }
        
        if (type === 'sum') {
            monthlyMap[month].usage += item.usage || 0;
            monthlyMap[month].costs += item.costs || 0;
        } else if (type === 'average') {
            monthlyMap[month].usage += item.usage || 0;
            monthlyMap[month].costs += item.costs || 0;
        }
        monthlyMap[month].count += 1;
    });
    
    const result = Object.values(monthlyMap);
    
    if (type === 'average') {
        result.forEach(item => {
            if (item.count > 0) {
                item.usage = item.usage / item.count;
                item.costs = item.costs / item.count;
            }
        });
    }
    
    // 按月份排序
    return result.sort((a, b) => new Date(a.month) - new Date(b.month));
}

// 聚合EUI数据
export const aggregateEuiData = (data, type = 'average') => {
    const monthlyMap = {};
    
    data.forEach(item => {
        const month = item.month;
        if (!monthlyMap[month]) {
            monthlyMap[month] = {
                month,
                rolling_eui: 0,
                count: 0
            };
        }
        
        monthlyMap[month].rolling_eui += item.rolling_eui || 0;
        monthlyMap[month].count += 1;
    });
    
    const result = Object.values(monthlyMap);
    
    if (type === 'average') {
        result.forEach(item => {
            if (item.count > 0) {
                item.rolling_eui = item.rolling_eui / item.count;
            }
        });
    }
    
    // 按月份排序
    return result.sort((a, b) => new Date(a.month) - new Date(b.month));
}

// 兼容旧接口的函数（保持向后兼容）
export const getCompanyEnergyData = getPortfolioEnergyData;
export const getCompanyEuiTrend = getPortfolioEuiTrend;